export const createStoryPageMessages = {
  // Step titles
  step1Title: 'Define Characters',
  step2Title: 'Preview Characters',
  step3Title: 'Add Dedication',
  step4Title: 'Story Preview',

  // Navigation
  stepIndicator: (current: number, total: number) =>
    `Step ${current} of ${total}`,
  createStory: 'Create Story',
  checkoutCtaButton: 'Go to Checkout',

  // Success Messages
  storyCreatedSuccess: 'Story created successfully!',

  // Error Messages
  storyNotFound: 'Story not found',
  styleTemplateRequired: 'Style template is required',
} as const;
